"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataService = void 0;
const core_1 = require("@apollo/client/core");
const common_1 = require("../common");
const classes_1 = require("./classes");
class DataService extends common_1.Service {
    constructor(currentProject = '') {
        super();
        this.currentProject$ = new common_1.ObjectSubject('');
        this.switchCurrentProject(currentProject);
    }
    get currentProject() {
        return this.currentProject$.value;
    }
    get headers() {
        let result = {};
        if (this.currentProject || this.currentProject === '') {
            const key = this.currentProject;
            result = {
                [common_1.HeaderNames.ProjectKey]: key,
            };
        }
        return result;
    }
    switchCurrentProject(currentProject) {
        this.currentProject$.nextData(currentProject);
        return this.currentProject;
    }
    async getAccountBalances(account, tokens, ChainId, provider) {
        const { apiService } = this.services;
        const { result } = await apiService.query((0, core_1.gql) `
        query($ChainId: Int!, $account: String!, $tokens: [String!], $provider: String) {
          result: accountBalances(chainId: $ChainId, account: $account, tokens: $tokens, provider: $provider) {
            items {
              token
              balance
              superBalance
            }
          }
        }
      `, {
            variables: {
                account,
                ChainId,
                tokens,
                provider
            },
            models: {
                result: classes_1.AccountBalances,
            },
        });
        return result;
    }
    async getTransaction(hash) {
        const { apiService } = this.services;
        const { result } = await apiService.query((0, core_1.gql) `
        query($chainId: Int, $hash: String!) {
          result: transaction(chainId: $chainId, hash: $hash) {
            blockHash
            blockNumber
            from
            gasLimit
            gasPrice
            gasUsed
            hash
            input
            logs
            nonce
            status
            timestamp
            to
            transactionIndex
            value
            blockExplorerUrl
            mainTransactionDataFetched
            internalTransactionsFetched
          }
        }
      `, {
            variables: {
                hash,
            },
            models: {
                result: classes_1.Transaction,
            },
        });
        return result;
    }
    async getNftList(account, ChainId) {
        const { apiService } = this.services;
        const { result } = await apiService.query((0, core_1.gql) `
        query($ChainId: Int, $account: String!) {
          result: nftList(chainId: $ChainId, account: $account) {
            items {
              contractName
              contractSymbol
              contractAddress
              tokenType
              nftVersion
              nftDescription
              balance
              items {
                tokenId
                name
                amount
                image
                ipfsGateway
              }
            }
          }
        }
      `, {
            variables: {
                account,
                ChainId,
            },
            models: {
                result: classes_1.NftList,
            },
        });
        return result;
    }
    async getExchangeSupportedAssets(page = null, limit = null, ChainId, account) {
        const { apiService } = this.services;
        try {
            const { result } = await apiService.query((0, core_1.gql) `
        query($ChainId: Int, $account: String!, $page: Int, $limit: Int) {
          result: exchangeSupportedAssets(chainId: $ChainId, account: $account, page: $page, limit: $limit) {
            items {
              address
              name
              symbol
              decimals
              logoURI
            }
            currentPage
            nextPage
          }
        }
      `, {
                variables: {
                    account,
                    ChainId,
                    page: page || 1,
                    limit: limit || 100,
                },
                models: {
                    result: classes_1.PaginatedTokens,
                },
            });
            return result;
        }
        catch (error) {
            console.error(error);
            return null;
        }
    }
    async getExchangeOffers(fromTokenAddress, toTokenAddress, fromAmount, fromChainId, toAddress, fromAddress, showZeroUsd) {
        const { apiService } = this.services;
        const account = fromAddress;
        const { result } = await apiService.query((0, core_1.gql) `
        query(
          $fromChainId: Int!
          $account: String!
          $fromTokenAddress: String!
          $toTokenAddress: String!
          $fromAmount: BigNumber!
          $toAddress: String
          $fromAddress: String
          $showZeroUsd: Boolean
        ) {
          result: exchangeOffers(
            chainId: $fromChainId
            account: $account
            fromTokenAddress: $fromTokenAddress
            toTokenAddress: $toTokenAddress
            fromAmount: $fromAmount
            toAddress: $toAddress
            fromAddress: $fromAddress
            showZeroUsd: $showZeroUsd
          ) {
            items {
              provider
              receiveAmount
              exchangeRate
              transactions {
                to
                data
                value
              }
            }
          }
        }
      `, {
            variables: {
                fromChainId,
                account,
                fromTokenAddress,
                toTokenAddress,
                fromAmount,
                toAddress,
                fromAddress,
                showZeroUsd,
            },
            models: {
                result: classes_1.ExchangeOffers,
            },
        });
        return result ? result.items : null;
    }
    async getAdvanceRoutesLiFi(fromTokenAddress, toTokenAddress, fromChainId, toChainId, fromAmount, toAddress, allowSwitchChain, fromAddress, showZeroUsd) {
        const { apiService } = this.services;
        const account = fromAddress;
        let data = null;
        const { result } = await apiService.query((0, core_1.gql) `
        query(
          $account: String!
          $fromTokenAddress: String!
          $toTokenAddress: String!
          $fromAmount: BigNumber!
          $fromChainId: Int
          $toChainId: Int
          $toAddress: String
          $allowSwitchChain: Boolean
          $fromAddress: String
          $showZeroUsd: Boolean
        ) {
          result: getAdvanceRoutesLiFi(
            account: $account
            fromTokenAddress: $fromTokenAddress
            toTokenAddress: $toTokenAddress
            fromAmount: $fromAmount
            fromChainId: $fromChainId
            toChainId: $toChainId
            toAddress: $toAddress
            allowSwitchChain: $allowSwitchChain
            fromAddress: $fromAddress
            showZeroUsd: $showZeroUsd
          ) {
            data
          }
        }
      `, {
            variables: {
                account,
                fromTokenAddress,
                toTokenAddress,
                fromChainId,
                toChainId,
                fromAmount,
                toAddress,
                allowSwitchChain,
                fromAddress,
                showZeroUsd,
            },
        });
        try {
            data = JSON.parse(result['data']);
        }
        catch (err) {
            console.log(err);
        }
        return data;
    }
    async getStepTransaction(selectedRoute, accountAddress) {
        const { apiService } = this.services;
        const account = accountAddress;
        let transactions = [];
        try {
            const route = JSON.stringify(selectedRoute);
            const { result } = await apiService.query((0, core_1.gql) `
        query(
          $route: String!
          $account: String!
        ) {
          result: getStepTransactions(
            route: $route
            account: $account
          ) {
              to
              gasLimit
              gasPrice
              data
              value
              chainId
              type
          }
        }`, {
                variables: {
                    route,
                    account,
                },
            });
            transactions = result;
        }
        catch (err) {
            console.log(err);
        }
        return {
            items: transactions
        };
    }
    async getCrossChainQuotes(fromTokenAddress, toTokenAddress, fromChainId, toChainId, fromAmount, serviceProvider, lifiBridges, toAddress, fromAddress, showZeroUsd) {
        const { apiService } = this.services;
        const account = fromAddress;
        const { result } = await apiService.query((0, core_1.gql) `
        query(
          $account: String!
          $fromTokenAddress: String!
          $toTokenAddress: String!
          $fromAmount: BigNumber!
          $fromChainId: Int
          $toChainId: Int
          $serviceProvider: CrossChainServiceProvider
          $lifiBridges: [LiFiBridge!]
          $toAddress: String
          $fromAddress: String
          $showZeroUsd: Boolean
        ) {
          result: getCrossChainQuotes(
            account: $account
            fromTokenAddress: $fromTokenAddress
            toTokenAddress: $toTokenAddress
            fromAmount: $fromAmount
            fromChainId: $fromChainId
            toChainId: $toChainId
            serviceProvider: $serviceProvider
            lifiBridges: $lifiBridges
            toAddress: $toAddress
            fromAddress: $fromAddress
            showZeroUsd: $showZeroUsd
          ) {
            items {
              provider
              approvalData {
                approvalAddress
                amount
              }
              transaction {
                data
                to
                value
                from
                chainId
              }
              estimate {
                approvalAddress
                fromAmount
                toAmount
                gasCosts {
                  limit
                  amountUSD
                  token {
                    address
                    symbol
                    decimals
                    logoURI
                    chainId
                    name
                  }
                }
                data {
                  fromToken {
                    address
                    symbol
                    decimals
                    logoURI
                    chainId
                    name
                  }
                  toToken {
                    address
                    symbol
                    decimals
                    logoURI
                    chainId
                    name
                  }
                  toTokenAmount
                  estimatedGas
                }
              }
              LiFiBridgeUsed
            }
          }
        }
      `, {
            variables: {
                account,
                fromTokenAddress,
                toTokenAddress,
                fromChainId,
                toChainId,
                fromAmount,
                serviceProvider,
                lifiBridges,
                toAddress,
                fromAddress,
                showZeroUsd,
            },
            models: {
                result: classes_1.BridgingQuotes,
            },
        });
        return result ? result : null;
    }
    async getTokenLists() {
        const { apiService } = this.services;
        try {
            const { result } = await apiService.query((0, core_1.gql) `
        query($chainId: Int) {
          result: tokenLists(chainId: $chainId) {
            items {
              name
              endpoint
              isDefault
              createdAt
              updatedAt
            }
          }
        }
      `, {
                models: {
                    result: classes_1.TokenLists,
                },
            });
            return result ? result.items : [];
        }
        catch (error) {
            console.error(error);
            return [];
        }
    }
    async getTokenListTokens(name = null) {
        const { apiService } = this.services;
        try {
            const { result } = await apiService.query((0, core_1.gql) `
        query($chainId: Int, $name: String) {
          result: tokenList(chainId: $chainId, name: $name) {
            tokens {
              address
              name
              symbol
              decimals
              logoURI
              chainId
            }
          }
        }
      `, {
                variables: {
                    name,
                },
                models: {
                    result: classes_1.TokenList,
                },
                fetchPolicy: 'cache-first',
            });
            return result ? result.tokens : [];
        }
        catch (error) {
            console.error(error);
            return [];
        }
    }
    async fetchExchangeRates(tokens, ChainId) {
        const { apiService } = this.services;
        try {
            const { result } = await apiService.query((0, core_1.gql) `
        query($tokens: [String!]!, $ChainId: Int!) {
          result: fetchExchangeRates(tokens: $tokens, chainId: $ChainId) {
            errored
            error
            items {
              address
              eth
              eur
              gbp
              usd
            }
          }
        }
      `, {
                variables: {
                    tokens,
                    ChainId,
                },
                models: {
                    result: classes_1.RateData,
                },
            });
            return result !== null && result !== void 0 ? result : null;
        }
        catch (error) {
            console.error(error);
            return null;
        }
    }
}
exports.DataService = DataService;
